export const description =
  'Sign up to receive our free monthly email covering the latest cases, contempts and more.'
